import { GroupProperties, jGroupView, UpdateGroup } from '../types/group';
import { extractTaxonomiesFromObject } from './taxonomy';

export const prepareGroupForUpdate = (group: jGroupView & GroupProperties): UpdateGroup => {
    let updateGroup: Partial<UpdateGroup> = {};
    if ('_errors' in group) {
        updateGroup._errors = group._errors;
    }
    if ('_options' in group) {
        updateGroup._options = group._options;
    }
    if ('title' in group) {
        updateGroup.title = group.title;
    }
    if ('description' in group) {
        updateGroup.description = group.description;
    }
    if ('activity' in group) {
        updateGroup.activity = group.activity;
    }
    if ('image' in group) {
        updateGroup.image = group.image;
    }
    if ('uri' in group) {
        updateGroup.uri = group.uri;
    }
    if ('type' in group) {
        updateGroup.type = group.type;
    }
    if ('edito' in group) {
        updateGroup.edito = group.edito;
    }
    if ('category' in group) {
        updateGroup.category = group.category.toString();
    }
    if ('commentLevel' in group) {
        updateGroup.commentLevel = group.commentLevel;
    }
    if ('_options' in group && group._options?.custom_widgets) {
        updateGroup.custom_widgets = Array.isArray(group._options.custom_widgets) ? {} : group._options.custom_widgets;
    }
    if ('displayType' in group) {
        updateGroup.displayType = group.displayType;
    }
    if ('language' in group) {
        updateGroup.language = group.language;
    }
    if ('edit_access' in group) {
        updateGroup.edit_access = group.edit_access;
    }
    if ('lock_mail' in group) {
        updateGroup.lock_mail = group.lock_mail;
    }
    if ('fileSyncEnabled' in group) {
        updateGroup.fileSyncEnabled = group.fileSyncEnabled;
    }
    if ('fileSyncVersioningType' in group) {
        updateGroup.fileSyncVersioningType = group.fileSyncVersioningType;
    }
    if ('fileBankQuota' in group) {
        updateGroup.fileBankQuota = group.fileBankQuota;
    }
    if ('idCommunity' in group) {
        updateGroup.idCommunity = group.idCommunity;
    }
    if ('lastRssExecution' in group) {
        updateGroup.lastRssExecution = group.lastRssExecution;
    }
    if ('mail_comment' in group) {
        updateGroup.mail_comment = group.mail_comment;
    }
    if ('mail_frequency' in group) {
        updateGroup.mail_frequency = group.mail_frequency;
    }
    if ('mail_spotit' in group) {
        updateGroup.mail_spotit = group.mail_spotit;
    }
    if ('mail_subscriber' in group) {
        updateGroup.mail_subscriber = group.mail_subscriber;
    }
    if ('notifyFolder' in group) {
        updateGroup.notifyFolder = group.notifyFolder;
    }
    if ('nounsubscribe' in group) {
        updateGroup.nounsubscribe = group.nounsubscribe;
    }
    if ('privacy' in group) {
        updateGroup.privacy = group.privacy;
    }
    if ('publishFolder' in group) {
        updateGroup.publishFolder = group.publishFolder;
    }
    if ('rss_access' in group) {
        updateGroup.rss_access = group.rss_access;
    }
    if ('rss_feed' in group) {
        updateGroup.rss_feed =
            group.rss_feed && Array.isArray(group.rss_feed)
                ? JSON.stringify(
                      group.rss_feed.map(({ _user, ...rssEntry }) => ({
                          ...rssEntry,
                          idUser: _user?.id,
                      })),
                  )
                : '[]';
    }
    if ('rss_key' in group) {
        updateGroup.rss_key = group.rss_key;
    }
    if ('spot_right_user' in group) {
        updateGroup.spot_right_user = group.spot_right_user;
    }
    if ('spotBanner' in group) {
        updateGroup.spotBanner = group.spotBanner;
    }
    if ('spotDefaultPublishType' in group) {
        updateGroup.spotDefaultPublishType = group.spotDefaultPublishType;
    }
    if ('user_level_signup' in group) {
        updateGroup.user_level_signup = group.user_level_signup;
    }
    if ('useTeaser' in group) {
        updateGroup.useTeaser = group.useTeaser;
    }
    if ('widgets' in group) {
        updateGroup.widgets = group.widgets;
    }
    const taxonomies = extractTaxonomiesFromObject(group);
    updateGroup = { ...updateGroup, ...taxonomies };

    if (checkProperties(group, updateGroup)) {
        return updateGroup;
    }

    /* istanbul ignore next */
    throw new Error();
};

export const checkProperties = (
    group: jGroupView & GroupProperties,
    updateGroup: Partial<UpdateGroup>,
): updateGroup is UpdateGroup => {
    const NOT_MAPPED_PROPERTIES = [
        'id',
        'mainType',
        'dateCreation',
        'dateModified',
        '_url',
        'o2apLinksSources', // Action plan app config
    ];
    const EXTRA_PROPERTIES = ['custom_widgets'];

    const groupProperties = Object.keys(group);
    const updateGroupProperties = Object.keys(updateGroup);
    const diffMissingProperties = groupProperties.filter(
        (p) => !updateGroupProperties.includes(p) && !NOT_MAPPED_PROPERTIES.includes(p),
    );
    const diffExtraProperties = updateGroupProperties.filter(
        (p) => !groupProperties.includes(p) && !EXTRA_PROPERTIES.includes(p),
    );
    const diff = [...diffMissingProperties.map((p) => '- ' + p), ...diffExtraProperties.map((p) => '+ ' + p)];
    if (diffMissingProperties.length > 0 || diffExtraProperties.length > 0) {
        throw new Error(`prepareGroupForUpdate :: Wrong group mapping | Diff : ${JSON.stringify(diff)}`);
    }
    return true;
};
